module.exports = __webpack_public_path__ + "img/notification-icon.a95ea102.png";